// extracted by css-extract-rspack-plugin
export default {"rulerIcon":"_3eff7c26"};